import { Button, Drawer, DrawerProps, Space } from "antd";
import React from "react";
import { MasterConfigs } from "../../interfaces/entity";

interface Props {
    children: React.ReactNode;
    submitForm: () => void;
    forceClose?: () => void;
    loading: boolean;
    handleCancel: () => void;
    maskClosable?: boolean;
    visible: boolean;
    isView: boolean;
    title?: string | React.ReactNode;
    rest?: DrawerProps
    config?: MasterConfigs;
    stepsIndex?: { current: number, lastIndex: number };
}

const DrawerComponent: React.FC<Props> = ({ children, submitForm, loading, handleCancel, maskClosable = false, visible, isView, title, config, forceClose, ...rest }) => {

    return <Drawer
        maskClosable={maskClosable}
        width={1000}
        title={title}
        placement="right"
        onClose={() => {
            if (forceClose) {
                forceClose();
            } else {
                handleCancel();
            }
        }}
        open={visible}
        destroyOnClose={true}
        footer={
            isView
                ? null
                : <Space direction="horizontal">
                    <Button
                        key="back"
                        onClick={handleCancel}
                        className="mr-2"
                    >
                        {(config?.isSteps && rest?.stepsIndex?.current > 0) ? 'Previous' : 'Cancel'}
                    </Button>
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={() => {
                            submitForm();
                        }}
                    >
                        {(config?.isSteps && rest?.stepsIndex?.current != rest?.stepsIndex?.lastIndex) ? 'Save & Next' : 'Save'}
                    </Button>
                </Space>
        }
        footerStyle={{ textAlign: 'end' }}
        {...rest?.rest}
    >
        {children}
    </Drawer>
}

export default DrawerComponent;